// extracted by mini-css-extract-plugin
export default {"container":"Team_container__Wbhxc","row":"Team_row__qnbG8"};